import { Directive, Input, Self, ElementRef } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { Observable } from 'rxjs'
@Directive({
	selector: '[numberfield]'
})
export class NumberField implements ControlValueAccessor {
	@Input() allowNegative: boolean = false;
	@Input() integer: boolean = false;
	private originalValueAccessor;
	private keyEventStream: Observable<KeyboardEvent>

	constructor( @Self() private ngControl: NgControl, private inputElement: ElementRef) {
		this.keyEventStream = <Observable<KeyboardEvent>>Observable.fromEvent(inputElement.nativeElement, 'keydown')
		this.originalValueAccessor = ngControl.valueAccessor
		ngControl.valueAccessor = this;
		this.originalValueAccessor.registerOnChange(this.updateValue)
	}

	updateValue = (newVal) => {
		let val = this.sanitizeValue(newVal);
		this.inputElement.nativeElement.value = val;
		this.updateControlValueAccessor(val);
	}

	sanitizeValue = (str: string) => {
		if (!str) return ""
		let regEx;
		if (this.integer) {
			if (this.allowNegative) {
				regEx = /[^0-9-]/g;
			} else {
				regEx = /[^0-9]/g;
			}
		} else {
			if (this.allowNegative) {
				regEx = /[^0-9,.-]/g;
			} else {
				regEx = /[^0-9,.]/g;
			}
		}
		let sanitizedVal = str.replace(regEx, '');
		if ((sanitizedVal.slice(-1).match("[,\.]") != null) && ((sanitizedVal.match(/[,\.]/g) || []).length > 1)) {
			sanitizedVal = sanitizedVal.slice(0, -1)
		}
		const validExpr = this.allowNegative ? "^[-]?[0-9]+[,\.]?[0-9]*$" : "^[0-9]+[,\.]?[0-9]*$"
		const isMinusAndAllowNegative = this.allowNegative && sanitizedVal === "-"
		if (isMinusAndAllowNegative === false && sanitizedVal.match(validExpr) === null) {
			sanitizedVal = "";
		}
		return sanitizedVal;
	}

	writeValue(obj: any): void {
		this.originalValueAccessor.writeValue(obj);
	}

	registerOnChange(fn: any): void {
		this.controlValueAccessorChanged = fn;
	}

	registerOnTouched(fn: any): void {
		this.controlValueAccessorTouched = fn;
	}

	controlValueAccessorChanged = (_) => { };
	controlValueAccessorTouched = () => { };

	updateControlValueAccessor(value: string) {
		this.controlValueAccessorTouched();
		if (!value || value === "-") {
			this.controlValueAccessorChanged(null);
			return;
		}
		this.controlValueAccessorChanged(value);
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/number-field/number-field.component.ts